
<DataPage
  ref="documentsDataPage"
  :fetch-callback="fetchDocuments"
  :model="DocumentModel"
  list
>
  <template #pageHeader>
    <slot name="pageHeader" />
  </template>

  <template #tableHeaderActions>
    <b-button
      v-can-dynamic:[permission.upload]
      variant="primary"
      size="sm"
      @click="openUploadModal"
    >
      <Icon icon="cloud-upload" size="14" class="mr-2" />
      {{ __('buttons.upload') }}
    </b-button>
  </template>

  <template #iconBlock="{ item }">
    <img :src="item.fileTypeIconName()" :alt="item.name" width="48" />
  </template>

  <template #label="{ item }">
    <RouterLink
      v-if="item.isFolder"
      v-can-dynamic:[permission.view]
      :to="{
        name: documentsRouteName,
        query: { path: getFolderRoutePath(item.name) },
      }"
    >
      {{ item.name }}
    </RouterLink>
    <a
      v-else
      v-can-dynamic:[permission.download]
      href="#"
      @click.prevent="preview(item)"
    >
      {{ item.name }}
    </a>
  </template>

  <template #badge="{ item }">
    <Badge v-if="item.getFileType()" variant="soft-secondary" class="ml-3">
      {{ item.getFileType() }}
    </Badge>
  </template>

  <template #description="{ item }">
    <span class="text-muted">
      {{ item.description() }}
    </span>
  </template>

  <template #actionButtons="{ item }">
    <Badge v-if="item.type" variant="soft-info" class="ml-3">
      {{ item.type.name }}
    </Badge>

    <ActionPopover
      :id="item.id"
      v-can-any="[permission.download, 'documents.destroy']"
    >
      <b-button
        v-if="!item.isFolder"
        v-can-dynamic:[permission.download]
        class="dropdown-item"
        size="sm"
        @click="preview(item)"
      >
        <Icon icon="eye" class="mr-2" size="14" />
        Preview
      </b-button>

      <b-button
        v-if="!item.isFolder"
        v-can-dynamic:[permission.download]
        class="dropdown-item"
        size="sm"
        @click="download(item)"
      >
        <Icon icon="cloud-download" class="mr-2" size="14" />
        {{ __('buttons.download') }}
      </b-button>

      <b-button
        v-if="!item.isFolder"
        v-can:documents.destroy
        class="dropdown-item"
        size="sm"
        @click="remove(item.id)"
      >
        <Icon icon="trash" class="mr-2" size="14" />
        {{ __('buttons.delete') }}
      </b-button>
    </ActionPopover>
  </template>
</DataPage>
